import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet-async';
import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private';
import {Header} from 'presentation/pages/public/components/Header';
import {translations} from 'presentation/translations-new';
import {StyledGrid} from 'presentation/components';
import {FooterMobile} from 'presentation/components/MainFooter/FooterMobile';
import {LoginEnum} from 'main/analytics/gaTagsEnum';
import {PublicFlowEnum} from '../constants/PublicFlowEnum';
import {useSteps} from '../hooks';
import {SectionContent, StyledBox} from '../styles';
import {Step1, Step2, Step4} from './components';
import {NeedHelpPage} from './components/NeedHelpPage';

const {headTitle, personalInfo, securityCode, newPasswordHeader, needHelp} =
	translations['pt-br'].publicFlow.forgotPassword;

export function ForgotPassword() {
	const {dataHostNameState} = useHostName();
	const {currentStepState} = useSteps(PublicFlowEnum.FORGOT_PASSWORD);
	const {isTablet} = useMediaQueries();

	const {productName} = dataHostNameState;
	const title = `${headTitle} | ${productName}`;

	const STEP_HEADER: Record<number, string> = {
		1: personalInfo,
		2: securityCode,
		3: newPasswordHeader,
		4: needHelp,
	};

	const isNewPasswordStep = currentStepState === 3;

	const TOTAL_STEPS = 3;
	const STEP_PAGE: Record<number, React.JSX.Element> = {
		1: <Step1 />,
		2: <Step2 />,
		3: <Step4 />,
		4: <NeedHelpPage />,
	};

	return (
		<Fragment>
			<Helmet>
				<title>{title}</title>
			</Helmet>

			<StyledGrid.Root>
				<StyledGrid.Item sm={12} md={12} lg={12}>
					<Header
						dataTagId={
							isNewPasswordStep
								? LoginEnum.CLICK_VOLTAR_ESQUECI_MINHA_SENHA
								: undefined
						}
						showProgressBar={currentStepState !== 4}
						headerTitle={STEP_HEADER[currentStepState]}
						totalSteps={TOTAL_STEPS}
						stepType={PublicFlowEnum.FORGOT_PASSWORD}
					/>
					<SectionContent>{STEP_PAGE[currentStepState]}</SectionContent>
				</StyledGrid.Item>
			</StyledGrid.Root>

			<StyledBox>
				<FooterMobile hideANS={!isTablet} />
			</StyledBox>
		</Fragment>
	);
}
